import type * as React from "react";
import { createFileRoute } from "@tanstack/react-router";

import { AdminUsers } from "@/features/admin/components/AdminUsers";

/**
 * Admin > Utenti — list route.
 *
 * Sibling to ``$userId.tsx`` (detail) under ``_modal/admin``. Previously the
 * list lived at ``_modal/admin/users.tsx`` (file-only), which TanStack
 * treated as the PARENT route of ``users/$userId.tsx``. Because ``AdminUsers``
 * doesn't render ``<Outlet/>``, the child detail route never mounted — the
 * detail was rendered THROUGH the parent as a right-side drawer. Moving the
 * list into ``users/index.tsx`` makes list + detail SIBLINGS so the detail
 * can mount as its own full-width ``UserDetailShell`` (mirrors the org-detail
 * fix in ``orgs/index.tsx``).
 */
export const Route = createFileRoute("/_authed/_modal/admin/users/")({
  component: AdminUsersRoute,
});

function AdminUsersRoute(): React.ReactElement {
  return <AdminUsers />;
}
